import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-34" data-mp="196ygwjgsma9m">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-35" data-mp="197zouf2iign4">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex min-h-[58px] w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-2 border-white/80 bg-cta px-4 py-3 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(22,163,74,0.7)] transition-colors duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-36" data-mp="2f5vaswzpj9gj">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="1if33anquapqd" />
            <span data-id="element-38" data-mp="1nc33wj4x70a3">Get it now · only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}